export const NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2 = {
  padding: '0px',
  borderRadius: '0px',
  gap: '8px',
  background: 'transparent',
  borderWidth: '0px',
  borderStyle: 'solid',
  borderColor: 'transparent',
};
